import { useState, useCallback, useRef } from "react";

export interface Toast {
  id: number;
  message: string;
  type?: "info" | "success" | "error";
  icon?: string;
}

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const nextId = useRef(0);

  const show = useCallback((message: string, opts?: { type?: Toast["type"]; icon?: string; duration?: number }) => {
    const id = ++nextId.current;
    setToasts((t) => [...t, { id, message, type: opts?.type ?? "info", icon: opts?.icon }]);
    setTimeout(() => {
      setToasts((t) => t.filter((x) => x.id !== id));
    }, opts?.duration ?? 2800);
  }, []);

  const dismiss = useCallback((id: number) => {
    setToasts((t) => t.filter((x) => x.id !== id));
  }, []);

  return { toasts, show, dismiss };
}
